/**
 * 이모지 감지 및 제거 정규식
 *
 * 지원하는 이모지 유형:
 * - 일반 이모지: 😀 👍 🎉
 * - 복합 이모지: 👨‍👩‍👧‍👦 (ZWJ 사용)
 * - 국가 플래그: 🇰🇷 🇺🇸 🇯🇵 🇺🇳
 * - 기호 및 Dingbats: ★ ☆ ✨
 *
 * 주의: 100% 모든 유니코드 이모지를 커버하지는 않으며, 일반적인 이모지 사용을 대상으로 함
 * - emoji-regex 라이브러리는 번들 크기 증가 (14KB+)
 * - 글로벌 메신저 급의 완벽한 필터링이 필요하다면 emoji-regex 고려
 * - 구형 환경에서는 fallback 범위만 검사
 */

// 이모지 정규식 패턴 (플래그 제외)
const PATTERN_FLAG = '[\u{1F1E6}-\u{1F1FF}]{2}';
const PATTERN_PICTO = '\\p{Extended_Pictographic}(?:\\uFE0F|\\u200D\\p{Extended_Pictographic})*';
const PATTERN_VARIATION = '[\\uFE0F\\uFE0E]';
const PATTERN_RANGES = '[\\u{1F300}-\\u{1F9FF}\\u{2600}-\\u{26FF}\\u{2700}-\\u{27BF}]';

// 이모지 감지용 정규식 (전역 플래그 없음)
const RE_FLAG_DETECT = new RegExp(PATTERN_FLAG, 'u');
const RE_PICTO_DETECT = new RegExp(PATTERN_PICTO, 'u');
const RE_VARIATION_DETECT = new RegExp(PATTERN_VARIATION, 'u');
const RE_RANGES_DETECT = new RegExp(PATTERN_RANGES, 'u');

// 이모지 제거용 정규식 (전역 플래그 있음)
const RE_FLAG_REMOVE = new RegExp(PATTERN_FLAG, 'gu');
const RE_PICTO_REMOVE = new RegExp(PATTERN_PICTO, 'gu');
const RE_VARIATION_REMOVE = new RegExp(PATTERN_VARIATION, 'gu');
const RE_RANGES_REMOVE = new RegExp(PATTERN_RANGES, 'gu');

/**
 * 문자열에 이모지가 포함되어 있는지 검사
 */
export const hasEmoji = (text: string): boolean => {
  try {
    return (
      RE_PICTO_DETECT.test(text) ||
      RE_FLAG_DETECT.test(text) ||
      RE_VARIATION_DETECT.test(text) ||
      RE_RANGES_DETECT.test(text)
    );
  } catch {
    return /[\u{1F300}-\u{1FAFF}]/u.test(text);
  }
};

/**
 * 문자열에서 이모지를 제거
 */
export const removeEmoji = (text: string): string => {
  try {
    return text
      .replace(RE_PICTO_REMOVE, '')
      .replace(RE_FLAG_REMOVE, '')
      .replace(RE_VARIATION_REMOVE, '')
      .replace(RE_RANGES_REMOVE, '');
  } catch {
    return text.replace(/[\u{1F300}-\u{1FAFF}]/gu, '');
  }
};

/**
 * 하이픈이 포함된 휴대폰 번호 검증 (010-1234-5678, 010-123-4567 등)
 */
export const isValidPhoneNumberWithHyphen = (phoneNumber: string): boolean => {
  const phoneNumberRegex = /^01[0-9]-[0-9]{3,4}-[0-9]{4}$/;
  return phoneNumberRegex.test(phoneNumber);
};

/**
 * 하이픈이 포함되지 않은 휴대폰 번호 검증 (01012345678 등)
 */
export const isValidPhoneNumber = (phoneNumber: string): boolean => {
  const phoneNumberRegex = /^01[0-9]{8,9}$/;
  return phoneNumberRegex.test(phoneNumber);
};

export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};
